import { defineComponent } from "vue";
import { definePropType } from "@types-vue/props";
import CommonHotPicture from "./common-hot-picture.vue";
import CommonPictureList from "./common-picture-list.vue";
import TagList from "./tag-list.vue";
import { tabTypeList } from "./resource-manage";
import { tabNameList } from "./config";
export default defineComponent({
    props: {
        resources: {
            type: definePropType(Array),
            default: function() {
                return [];
            }
        },
        currentTab: {
            type: definePropType(Object),
            default: function() {
                return {
                    key: "",
                    tagId: "",
                    search: "",
                    componentsTitle: "",
                    type: 0,
                    listTagId: ""
                };
            }
        },
        tagList: {
            type: definePropType(Array),
            default: function() {
                return [];
            }
        }
    },
    components: {
        CommonHotPicture: CommonHotPicture,
        CommonPictureList: CommonPictureList,
        TagList: TagList
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var handleAddResource = function(res) {
            emit("addResource", res);
        };
        var viewTagAllData = function(tagInfo) {
            emit("viewTagAllData", tagInfo);
        };
        var getCommonHotComponents = function() {
            emit("backCommonHotComponents");
        };
        var getCommonComponentsByTag = function(id, type) {
            emit("getCommonComponentsByTag", {
                id: id,
                type: type
            });
        };
        return {
            tabTypeList: tabTypeList,
            tabNameList: tabNameList,
            handleAddResource: handleAddResource,
            viewTagAllData: viewTagAllData,
            getCommonHotComponents: getCommonHotComponents,
            getCommonComponentsByTag: getCommonComponentsByTag
        };
    }
});
